module.exports = __webpack_public_path__ + "img/oneonone@2x.fa82a14.jpg";